//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { Locales } from 'app/constants/locales/locale';
import { termsConditionsSettings } from 'app/constants/rights-management/terms-and-conditions-settings';

export interface RightsRequestTCUrlParams {
  locale?: Locales;
  rightsRequestText: string | undefined;
}

export const useRightsRequestTCMessage = ({
  locale = Locales.EN_US,
  rightsRequestText,
}: RightsRequestTCUrlParams) => {
  const retailerMessages =
    termsConditionsSettings[locale]?.retailerMessages ?? [];
  const rightsRequestTCMessages = retailerMessages.filter((message) =>
    rightsRequestText?.includes(message),
  );

  return rightsRequestTCMessages.length > 0
    ? rightsRequestTCMessages[0]
    : undefined;
};
